<template>
  <div class="delivery-note-main">
    <div id="divMenu">
      <Menus
        :menu="menu"
        icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-new-file-64.png"
        @menuClicked="menuClicked"
      />
    </div>
    <div class="right-container">
      <div class="filter-area">
        <div>{{ filterText }}</div>
        <ButtonFilter
          class="button-filter"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="mainFilterIsOpen"
        >
          <div class="filter-item">
            <BoxContainer
              title="Date"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="dateFilterChecked"
            >
              <div class="dates">
                <DateTimePicker
                  :isDisabled="!dateFilterChecked"
                  style="margin-right: 5px"
                  placeholder="From"
                  :showTime="false"
                  :value.sync="fromDatePicker"
                />
                <DateTimePicker
                  :isDisabled="!dateFilterChecked"
                  style="margin-left: 5px; margin-right: 5px"
                  placeholder="To"
                  :showTime="false"
                  :value.sync="toDatePicker"
                />
              </div>
            </BoxContainer>
          </div>
          <div class="filter-item">
            <BoxContainer
              class="filter-check"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              title="Search"
              :isChecked.sync="searchFilterChecked"
            >
              <Dropdown
                placeholder="Search By"
                :items="searchFilterItems"
                itemKey="Search Criteria"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedSearchBy"
                :errorMessage.sync="searchByError"
                @selected="searchBySelected"
              />
              <Dropdown
                placeholder="Search Criteria"
                :items="searchCriteriaItems"
                itemKey="name"
                :isDisabled="!searchFilterChecked || criteriaDisabled"
                :isRequired="searchFilterChecked"
                :selectedObject.sync="selectedCriteria"
              />
              <Input
                placeholder="Search"
                :inputValue.sync="searchByValue"
                :isDisabled="!searchFilterChecked"
                :isRequired="searchFilterChecked"
                :errorMessage.sync="searchByValueError"
              />
            </BoxContainer>
          </div>
          <button @click="refreshClicked" :disabled="!dateFilterChecked && !searchFilterChecked">Refresh</button>
        </ButtonFilter>
        <div>Last Refreshed: {{ lastRefreshed }}</div>
      </div>
      <div class="tabulator-area">
        <TableBox
          id="destTabulator"
          tableID="destinationTable"
          :tableData="deliveryNotes"
          :multiSelect="1"
          :selectedRow.sync="selectedDN"
          title="Delivery Notes"
          :dataType="{
            'Delivery Note Date': 'date',
            Quantity: 'number',
            KG: 'number',
            M3: 'number',
            'Last Update': 'date',
          }"
        />
      </div>
    </div>

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popupEntryTitle"
      createdBy=""
      updatedBy=""
      :disabledSave="popupEntryTitle[0] == 'V'"
      @save="saveClicked"
      @requiredClicked="requiredClicked"
      :requiredError="popupEntryRequired"
      :successMessages="popupEntrySuccess"
      :messages="popupEntryMessages"
      :errorMessages="popupEntryError"
    >
      <div class="page2-popup">
        <!-- Page 2 -->
        <div class="popup-row">
          <Input placeholder="Delivery Note #" :isRequired="true" :inputValue.sync="dnno" :isDisabled="true" />
          <Input placeholder="Reference #" :inputValue.sync="refno" :isDisabled="viewMode" />
        </div>
        <DateTimePicker
          placeholder="Delivery Date/Time"
          :value.sync="dnDateTime"
          :isRequired="true"
          :isDisabled="viewMode"
        />
        <div class="popup-row">
          <div class="block-with-title">
            <div class="title">Lorry / Driver</div>
            <CheckBoxV2 title="Other Lorry No" :isChecked.sync="otherLorryNoChecked" :isDisabled="viewMode" />
            <Input
              v-if="otherLorryNoChecked"
              :isRequired="true"
              :inputValue.sync="otherLorryNo"
              placeholder="Lorry No"
              :isDisabled="viewMode"
            />
            <InputQuery
              v-else
              placeholder="Lorry No"
              :isRequired="true"
              :items="lorryNoList"
              :selectedObject.sync="selectedLorry"
              itemKey="Lorry No"
              descKey="Vehicle Code"
              :errorMessage.sync="VehicleNoError"
              ref="VehicleNo"
              :isDisabled="viewMode"
              @selected="onLorryChanged"
            />
            <InputQuery
              placeholder="Driver Code"
              :items="driverCodeList"
              :selectedObject.sync="selectedDriver"
              itemKey="Driver Code"
              descKey="Driver Name"
              @selected="driverCodeChanged"
              :isDisabled="viewMode"
            />
            <Input
              placeholder="Driver Name"
              :isRequired="true"
              :inputValue.sync="driverName"
              :errorMessage.sync="DriverNameError"
              ref="DriverName"
              :isDisabled="viewMode"
            />
            <Input placeholder="Driver IC" :inputValue.sync="driverIC" :isDisabled="viewMode" />
            <InputQuery
              placeholder="Transporter"
              :isRequired="true"
              :items="transporterList"
              :selectedObject.sync="selectedTransporter"
              itemKey="Creditor Code"
              descKey="Creditor Name"
              :errorMessage.sync="Ctr_CreditorError"
              ref="Ctr_Creditor"
              :isDisabled="viewMode"
            />
          </div>
          <div class="block-with-title">
            <div class="title">Job Details</div>
            <div v-if="selectedJob == null && popupEntryTitle[0] == 'N'" style="display: flex; flex-direction: row">
              <DateTimePicker placeholder="Start" :showTime="false" :value.sync="startDate" style="margin-right: 6px" />
              <DateTimePicker placeholder="End" :showTime="false" :value.sync="endDate" style="margin-right: 6px" />
              <button style="margin-right: 6px" @click="page1Refresh">Refresh</button>
            </div>
            <InputQuery
              placeholder="Job #"
              :items="jobsList"
              :isDisabled="selectedJob != null || popupEntryTitle[0] != 'N'"
              :search.sync="selectedJobNo"
              :selectedObject.sync="selectedJob"
              itemKey="Job_No"
              :showDesc="false"
              ref="jobNo"
              @selected="jobClicked"
              @focusChanged="jobFocusChanged"
              :allowFreeText="true"
            />
            <Input placeholder="Date / Time" :isDisabled="true" :inputValue.sync="jobDateTime" />
            <Input placeholder="Customer" :isDisabled="true" :inputValue.sync="customer" />
            <Input placeholder="Voyage #" :isDisabled="true" :inputValue.sync="voyno" />
            <Input placeholder="Vessel ETA" :isDisabled="true" :inputValue.sync="vesselETA" />
          </div>
        </div>
        <RemarksBox style="height: 75px" :maxLength="200" :text.sync="remarks" :isDisabled="viewMode" />
        <div class="popup-row" style="margin-top: 5px">
          <InputQuery
            placeholder="From"
            :isRequired="true"
            :items="fromList"
            :selectedObject.sync="selectedFrom"
            itemKey="Code - Name"
            descKey="Company"
            @selected="fromChanged"
            :errorMessage.sync="DepartureCodeError"
            ref="DepartureCode"
            :isDisabled="viewMode"
          />
          <InputQuery
            placeholder="To"
            :isRequired="true"
            :items="toList"
            :selectedObject.sync="selectedTo"
            itemKey="Code - Name"
            descKey="Company"
            @selected="toChanged"
            :errorMessage.sync="DestinationCodeError"
            ref="DestinationCode"
            :isDisabled="viewMode"
          />
        </div>
        <div class="popup-row">
          <textarea disabled v-model="fromAddress"></textarea>
          <textarea disabled v-model="toAddress"></textarea>
        </div>
        <div class="popup-row" style="margin-top: 5px">
          <div class="popup-row">
            <Input
              placeholder="Qty"
              style="width: 30%"
              :isRequired="true"
              :inputValue.sync="qty"
              :errorMessage.sync="QuantityError"
              ref="Quantity"
              :isDisabled="viewMode"
              validator="positiveDecimal,5,4"
            />
            <InputQuery
              placeholder="Package"
              style="width: 70%"
              :isRequired="true"
              :items="packageList"
              :selectedObject.sync="selectedPackage"
              itemKey="Package Code"
              descKey="Description"
              :errorMessage.sync="Package_CodeError"
              ref="Package_Code"
              :isDisabled="viewMode"
            />
          </div>
          <div class="popup-row">
            <Input
              placeholder="KG"
              :isRequired="true"
              :inputValue.sync="kg"
              :errorMessage.sync="GWeightError"
              ref="GWeight"
              :isDisabled="viewMode"
              validator="positiveDecimal,5,4"
            />
            <Input
              placeholder="M3"
              :isRequired="true"
              :inputValue.sync="m3"
              :errorMessage.sync="MeasurementError"
              ref="Measurement"
              :isDisabled="viewMode"
              validator="positiveDecimal,5,4"
            />
          </div>
        </div>
        <div class="popup-row">
          <RemarksBox
            style="height: 100px"
            title="Goods Description"
            :maxLength="500"
            :errorMessage.sync="goodsDescError"
            :text.sync="goodsDesc"
            :isDisabled="viewMode"
          />
          <RemarksBox
            style="height: 100px"
            title="Shipping Marks"
            :maxLength="500"
            :errorMessage.sync="shipMarksError"
            :text.sync="shipMarks"
            :isDisabled="viewMode"
          />
        </div>
        <div class="table-container" ref="dnTable">
          <div class="tabulator-title">
            <div style="flex-grow: 1; display: flex; justify-content: flex-end; margin-right: 5px"></div>
            <button v-if="!viewMode" @click="selectPackageClicked(false)">Select Package from Job</button>
            <button v-if="!viewMode" @click="deletePackageClicked(false)">Delete Package</button>
          </div>
          <TableBox
            title="Sub Package Details"
            tableID="subpkg"
            :tableData="dnSubPkgList"
            :selectedRow.sync="selectedDnSubPkgList"
            :hideColumns="subPkgHideColumns"
          />
        </div>
      </div>
    </PopupEntry>

    <PopupV2
      :show="showSelectPackagePopup"
      :title="'Select Package from Job ' + selectedJobNo.trim()"
      :buttons="selectPackageButtons"
      @buttonClicked="selectPackageButtonClicked"
      width="90%"
      height="90%"
    >
      Select a sub-package from the list below to specify the quantity.
      <div class="table-container">
        <div class="tabulator-title">
          <TableBox
            title="Sub Package Details"
            tableID="subpkg"
            :tableData="subPkgList"
            :selectedRow.sync="selectedCargoInfoData['selectedSubPkgs']"
            v-if="showSelectPackagePopup"
            style="height: calc(100% - 18px); width: 100%; padding: 3px; overflow: auto"
            :hideColumns="subPkgHideColumns"
          />
        </div>
      </div>
    </PopupV2>

    <PopupV2
      :show="showQtyPopup"
      title="Enter Package Quantity"
      :buttons="selectQtyButtons"
      @buttonClicked="qtyPopupButtonClicked"
      width="300px"
    >
      <Input
        style="margin-top: 10px"
        validator="positiveDecimal,5,4"
        :isRequired="true"
        :inputValue.sync="inputQty"
        placeholder="Quantity"
        ref="qtyInput"
      />
    </PopupV2>

    <PopupV2
      :show="popupShow"
      :type="popupType"
      :title="popupTitle"
      :content="popupContent"
      :buttons="popupButtons"
      @buttonClicked="popupButtonClicked"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      showSelectPackagePopup: false,
      subPkgList: [],
      selectPackageButtons: [{ text: 'Select All' }, { text: 'Close', color: 'lightgray' }],
      selectQtyButtons: [{ text: 'Confirm' }, { text: 'Cancel', color: 'lightgray' }],
      dnSubPkgList: [],
      selectedDnSubPkgList: [],
      selectedCargoInfoData: {
        gWeight: this.$weightFormat('0'), // default these to 0 because if saved empty it will be 0
        volume: this.$weightFormat('0'),
        chargeable: this.$weightFormat('0'),

        selectedCommodity: null,
        selectedPMaterial: null,
        packageCount: '',
        selectedPackageType: null,

        selectedSubPkgs: [],
        deletedSubPkg: [],
        contDetailsList: [],
        selectedContDetails: null,
        deletedContDetails: [],
      },
      showQtyPopup: false,
      inputQty: '0',
      subPkgHideColumns: ['Dimensions', 'Gross Weight', 'Net Weight', 'Volume', 'seq_no'],
      menu: [
        { title: 'New Delivery Note', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png' },
        { title: 'Edit Delivery Note', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png' },
        { title: 'Delete Delivery Note', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png' },
        { title: 'View Delivery Note', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png' },
        { title: 'Print Delivery Note', icon: 'https://dsmlib.logistics.systems/Icons/Print.png' },
        { title: 'e-Delivery Notes', icon: 'https://dsmlib.logistics.systems/Icons/eROT.png' },
      ],
      viewMode: false,
      fromDate: new Date(),
      toDate: new Date(),
      lastRefresh: '',
      mainFilterIsOpen: false,
      mainFilterIsDisabled: false,
      dateFilterChecked: true,
      searchFilterChecked: false,
      filterText: '',
      searchFilterItems: [],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedCriteria: null,
      selectedSearchBy: null,
      criteriaDisabled: false,
      searchByValue: '',
      searchByError: '',
      searchByValueError: '',

      tableLoading: false,
      deliveryNotes: [],
      selectedDN: [],

      popupEntryShow: false,
      popupEntryTitle: '',

      popupEntryRequired: [],
      popupEntrySuccess: [],
      popupEntryMessages: [],
      popupEntryError: [],

      // Page 1 Data
      selectedJobNo: '',
      startDate: new Date(),
      endDate: new Date(),
      jobsList: [],
      selectedJob: null,
      // Page 1 Data

      //Page 2 Data
      jobDetails: null,
      dnno: '',
      refno: '',
      dnDateTime: null,

      otherLorryNoChecked: false,
      otherLorryNo: '',
      lorryNoList: [],
      selectedLorry: null,
      driverCodeList: [],
      selectedDriver: null,
      driverName: '',
      driverIC: '',
      transporterList: [],
      selectedTransporter: null,

      jobno: '',
      jobDateTime: '',
      customer: '',
      voyno: '',
      vesselETA: '',

      remarks: '',

      fromList: [],
      selectedFrom: null,
      fromAddress: '',
      toList: [],
      selectedTo: null,
      toAddress: '',

      qty: '',
      packageList: [],
      selectedPackage: null,
      kg: '',
      m3: '',

      goodsDesc: '',
      shipMarks: '',

      VehicleNoError: '',
      DriverNameError: '',
      Ctr_CreditorError: '',
      DepartureCodeError: '',
      DestinationCodeError: '',
      QuantityError: '',
      Package_CodeError: '',
      GWeightError: '',
      MeasurementError: '',
      goodsDescError: '',
      shipMarksError: '',
      //Page 2 Data

      popupShow: false,
      popupType: '',
      popupTitle: '',
      popupContent: '',
      popupButtons: [],

      fromDatePicker: new Date(),
      toDatePicker: new Date(),
      lastRefreshed: '',
    };
  },
  props: {},
  methods: {
    menuClicked: async function (e) {
      this.mainFilterIsOpen = false;
      switch (e['title']) {
        case 'New Delivery Note': {
          const currentDate = new Date();
          this.startDate = new Date(currentDate);
          this.startDate.setDate(currentDate.getDate() - 7);
          await this.page1Refresh();
          this.viewMode = true;
          this.popupEntryShow = true;
          this.popupEntryTitle = 'New Delivery Note';
          this.dnno = '**************';
          this.$nextTick(() => {
            this.$refs['jobNo'].setFocus();
          });
          break;
        }
        case 'Edit Delivery Note':
          if (this.selectedDN.length == 0) {
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'No Delivery Note selected';
            this.popupContent = 'Please select a delivery note to edit';
          } else {
            this.viewMode = false;
            this.popupEntryShow = true;
            this.popupEntryTitle = 'Edit Delivery Note';
            this.populateEditDetails();
          }
          break;
        case 'Delete Delivery Note':
          this.popupShow = true;
          if (this.selectedDN.length == 0) {
            this.popupType = 'error';
            this.popupTitle = 'No Delivery Note selected';
            this.popupContent = 'Please select a delivery note to delete';
          } else {
            this.popupType = 'warning';
            this.popupTitle = 'Delete Delivery Note';
            this.popupContent = `Are you sure you want to delete Delivery Note ${this.selectedDN[0]['Delivery Note #']}? This cannot be undone.`;
            this.popupButtons = [
              { text: 'Delete', color: 'red', textColor: 'white' },
              { text: 'Cancel', color: 'lightgray' },
            ];
          }
          break;
        case 'View Delivery Note':
          if (this.selectedDN.length == 0) {
            this.popupShow = true;
            this.popupType = 'error';
            this.popupTitle = 'No Delivery Note selected';
            this.popupContent = 'Please select a delivery note to view';
          } else {
            this.viewMode = true;
            this.popupEntryShow = true;
            this.popupEntryTitle = 'View Delivery Note';
            this.populateEditDetails();
          }
          break;
        case 'Print Delivery Note':
          if (this.selectedDN.length == 0) {
            // this.popupShow = true;
            // this.popupType = 'error';
            // this.popupTitle = 'No Delivery Note selected';
            // this.popupContent = 'Please select a delivery note to print';
            const route = this.$router.resolve(
              `/Home/${this.$route.params['user']}/FreightForwarding/Print%20Delivery%20Notes`,
            );
            window.open(route.href, '_blank');
          } else {
            const route = this.$router.resolve(
              `/Home/${this.$route.params['user']}/FreightForwarding/Print%20Delivery%20Notes?dn=${this.selectedDN[0]['Delivery Note #'].split('/').join('%2f')}`,
            );
            window.open(route.href, '_blank');
          }
          this.printClicked();
          break;
        case 'e-Delivery Notes':
          window.open(`/Home/${this.$route.params['user']}/FreightForwarding/eDeliveryNotes`, '_blank');
          break;
      }
    },
    printClicked: function () {
      if (this.selectedRow[0] == undefined) {
        this.$showAlert('error', 'No Records Selected', 'Please select a record to print');
      } else {
        //const userID = JSON.parse(localStorage.getItem('loginDetails')).LoginUserID;
        //const configCode = JSON.parse(localStorage.getItem('loginDetails')).ConfigCode;
        const dnno = this.selectedRow[0]['Delivery Note #'].trim().replace(/[/]/g, '%2F');
        // window.open(`/GenerateDN/${userID}/${configCode}/${dnno}`, '_blank');
        window.open(`/Reports/Delivery Note/${dnno}`, '_blank');
      }
    },
    newClicked: function () {
      if (this.urlJobNoDnno != '' && this.urlAction == 'N') {
        this.getJobDetails(this.urlJobNoDnno);
        this.popupContent.popupData.disabledDeliveryNoteNo = false;
        this.saveAction = 'N';
        this.entryTitle = 'New Delivery Note';
        this.showPopup = true;
      } else {
        // this.jobMsg = ['Please Input or Select a Job No'];
        this.showJobPopup = true;
      }
    },
    viewEditClicked: function (status) {
      if (this.selectedRow[0] == undefined && this.urlAction != 'E') {
        this.$showAlert('error', 'No Delivery Note Selected', `Please select a record to ${status}`);
      } else {
        this.$fullscreenLoading('Getting Delivery Note Details');
        this.clearForm();
        if (this.urlJobNoDnno != '') {
          this.retrieveTable(this.urlJobNoDnno);
        } else {
          this.retrieveTable(this.selectedRow[0]['Delivery Note #'].trim());
        }
        this.popupContent.popupData.disabledDeliveryNoteNo = true;
        if (status == 'edit') {
          this.entryTitle = 'Edit Delivery Note';
          this.saveAction = 'E';
          this.viewMode = false;
        } else if (status == 'view') {
          this.entryTitle = 'View Delivery Note';
          this.viewMode = true;
        }
        this.showPopup = true;
        this.$fullscreenLoading();
      }
    },
    refreshClicked: async function () {
      this.selectedDN = [];
      this.deliveryNotes = [];
      this.searchByError = '';
      this.searchByValueError = '';

      if (this.searchFilterChecked && (!this.selectedSearchBy || !this.searchByValue)) {
        this.searchByError = !this.selectedSearchBy ? 'Please select your search criteria' : '';
        this.searchByValueError = !this.searchByValue ? 'Please enter your search value' : '';
        return;
      }
      const dataToPost = {
        startdate: this.dateFilterChecked ? new Date(this.fromDatePicker).formatString('yyyy-MM-dd') : '',
        enddate: this.dateFilterChecked ? new Date(this.toDatePicker).formatString('yyyy-MM-dd') : '',
        searchfield: this.searchFilterChecked ? this.selectedSearchBy['Search Criteria'] : '',
        searchcriteria: this.searchFilterChecked ? this.selectedCriteria['name'] : '',
        searchvalue: this.searchFilterChecked ? this.searchByValue : '',
      };

      if (this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}, from ${new Date(this.fromDatePicker).formatString('yyyy-MM-dd')} to ${new Date(this.toDatePicker).formatString('yyyy-MM-dd')}`;
      } else if (this.dateFilterChecked && !this.searchFilterChecked) {
        this.filterText = `Filter by date from ${new Date(this.fromDatePicker).formatString('yyyy-MM-dd')} to ${new Date(this.toDatePicker).formatString('yyyy-MM-dd')}`;
      } else if (!this.dateFilterChecked && this.searchFilterChecked) {
        this.filterText = `Filter by ${this.selectedSearchBy['Search Criteria']} ${this.selectedCriteria['name']} ${this.searchByValue}`;
      }

      this.$fullscreenLoading('Getting Delivery Note');
      this.deliveryNotes = await this.$apiCallV2('/DeliveryNotes/GetDeliveryNoteListing', dataToPost);
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm:ss');
      this.deliveryNotes = this.deliveryNotes.map((item) => {
        if (item.Remarks && typeof item.Remarks === 'string') {
          // weishen 20240426 - replace all newline characters with <br> only in the Remarks field
          item.Remarks = item.Remarks.replace(/\n/g, '<br>');
        }
        if (item['Goods Description'] && typeof item['Goods Description'] === 'string') {
          item['Goods Description'] = item['Goods Description'].replace(/\n/g, '<br>');
        }
        if (item['Shipping Marks'] && typeof item['Shipping Marks'] === 'string') {
          item['Shipping Marks'] = item['Shipping Marks'].replace(/\n/g, '<br>');
        }
        return item;
      });
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm:ss');
      this.mainFilterIsOpen = false;
      this.$fullscreenLoading();
    },
    nextClicked: function () {
      this.$fullscreenLoading('Getting Job Details');
      this.showJobPopup = false;
      this.getJobDetails(this.jobPopupContent.popupData.deliveryJobNo);
      this.popupContent.popupData.disabledDeliveryNoteNo = false;
      this.saveAction = 'N';
      this.entryTitle = 'New Delivery Note';
      this.showPopup = true;
    },
    //Button Actions
    jobFocusChanged: function (val) {
      if (!val) {
        // unfocused
        this.$nextTick(() => {
          if (this.selectedJobNo) {
            this.jobClicked(this.selectedJobNo);
          }
        });
      }
    },
    jobClicked: async function (val) {
      if (val) {
        this.selectedJobNo = val['Job_No'] ? val['Job_No'] : this.selectedJobNo;
        this.clearAllPopupEntryMessages();

        this.$fullscreenLoading('Getting Job Details');
        this.jobDetails = (
          await this.$apiCallV2(
            `/DeliveryNotes/GetJobDetails?jobno=${val['Job_No'] ? val['Job_No'] : this.selectedJobNo}`,
          )
        )[0];
        if (!this.jobDetails || Object.keys(this.jobDetails).length === 0) {
          this.$fullscreenLoading();
          this.$showAlert('error', 'Invalid Job No', `Job No ${this.selectedJobNo} does not exist.`);
          this.selectedJob = null;
          this.selectedJobNo = '';
          return;
        }
        this.populateJobDetails();

        if (this.defaultValueToPopulate) {
          if (this.defaultValueToPopulate.length > 0) {
            //#region For Default Lorry
            const lorry = this.lorryNoList.getSelected(this.defaultValueToPopulate[0]['DN_DefaultLorry'] || '', 'Lorry No');
            if (lorry) {
              this.otherLorryNoChecked = false;
              this.selectedLorry = lorry;
            } else {
              this.otherLorryNoChecked = true;
              this.$nextTick(() => (this.otherLorryNo = this.defaultValueToPopulate[0]['DN_DefaultLorry']));
            }
            //#endregion

            //#region For Default Driver
            const driver = this.driverCodeList.getSelected(
              this.defaultValueToPopulate[0]['DN_DefaultDriver'] || '',
              'Driver Name',
            );
            if (driver) {
              this.selectedDriver = driver;
              this.$nextTick(() => this.driverCodeChanged(this.selectedDriver));
            } else {
              this.driverName = this.defaultValueToPopulate[0]['DN_DefaultDriver'] || '';
            }
            //#endregion

            //#region For Default Transporter
            this.selectedTransporter = this.transporterList.getSelected(
              this.defaultValueToPopulate[0]['DefaultTransporter'] || '',
              'Creditor Code',
            );
            //#endregion
          }
        }

        this.dnDateTime = new Date();
        this.viewMode = false;
        this.$fullscreenLoading();
      } else {
        this.viewMode = true;
      }
    },
    //Save Clicked
    saveClicked: async function () {
      this.clearAllPopupEntryMessages();

      if (this.goodsDesc.length > 500) {
        this.goodsDescError = 'Goods Description cannot exceed 500 characters!';
        return;
      }
      if (this.shipMarks.length > 500) {
        this.shipMarksError = 'Shipping Marks cannot exceed 500 characters!';
        return;
      }

      const action = this.popupEntryTitle[0];
      const dataToPost = {
        lastupdate: action == 'N' ? '' : new Date().formatString('yyyy-MM-dd HH:mm:ss'),
        action: action,
        rotNo: action == 'N' ? '' : this.dnno,
        job_No: this.selectedJobNo,
        refNo: this.refno,
        rotDate: this.dnDateTime ? new Date(this.dnDateTime).formatString('yyyy-MM-dd') : '',
        rotTime: this.dnDateTime ? new Date(this.dnDateTime).formatString('HHmm') : '',
        departureCode: this.selectedFrom ? this.selectedFrom['Destination Code'] : '',
        destinationCode: this.selectedTo ? this.selectedTo['Destination Code'] : '',
        vehicleNo:
          this.otherLorryNoChecked ? this.otherLorryNo
          : this.selectedLorry ? this.selectedLorry['Lorry No']
          : '',
        driverName: this.driverName,
        driverNRIC: this.driverIC,
        driverMobileNo: '',
        quantity: this.qty,
        package_Code: this.selectedPackage ? this.selectedPackage['Package Code'] : '',
        remarks: this.remarks,
        goodsDescription: this.goodsDesc,
        shipMarks: this.shipMarks,
        system: '',
        gWeight: this.kg,
        measurement: this.m3,
        ctr_Creditor: this.selectedTransporter ? this.selectedTransporter['Creditor Code'] : '',
        ctr_CreditorAtt: '',
        ctr_CreditorTel: this.selectedTransporter ? this.selectedTransporter['Tel No'] : '',
        ctr_TruckSize: '',
        ctr_TruckType: '',
        ctr_ConfirmBy: '',
        ctr_TransportCharge: '',
        rotNoPackingList: this.dnno,
      };
      dataToPost['packinglist'] = this.formatPkgList();


      this.$fullscreenLoading('Saving Delivery Note');
      const saveResults = await this.$apiCallV2('/DeliveryNotes/SaveDeliveryNote', dataToPost);
      this.$fullscreenLoading();

      if (Array.isArray(saveResults)) {
        // Completed from API
        if (saveResults[0]['Results'] == 0) {
          // Save successful
          this.popupEntrySuccess.push(
            action == 'N' ?
              `Successfully created a new Delivery Note # ${saveResults[0]['DeliveryNote']}`
            : `Successfully edited Delivery Note ${saveResults[0]['DeliveryNote']}`,
          );

          //refesh the data
          this.clearData();
          this.viewMode = true;
          this.popupEntryTitle = 'View Delivery Note';
          this.populateEditDetails(saveResults[0]['DeliveryNote']);

          this.refreshClicked();
        } else {
          // Save error
          this.popupEntryError.push(saveResults[0]['ErrMsg']);
        }
      } else {
        // Data Annotation error]
        this.popupEntryRequired = saveResults['error'].map((e) => {
          return { Key: e['key'], Value: e['value'] };
        });
        saveResults['error'].forEach((e) => {
          this[`${e['key']}Error`] = e['value'];
        });
      }
    },
    populateJobDetails: function () {
      // this.dnno = '';
      // this.refno = '';
      // this.dnDateTime = null;

      // this.lorryNoList = [];
      // this.selectedLorry = null;
      // this.driverCodeList = [];
      // this.selectedDriver = null;
      // this.driverName = '';
      // this.driverIC = '';
      // this.transporterList = [];
      // this.selectedTransporter = null;

      this.selectedJobNo = this.jobDetails['Job_No'] ? this.jobDetails['Job_No'].trim() : '';
      this.jobDateTime = `${this.jobDetails['Job_Date'] || ''} ${this.jobDetails['Job_Time'] ? `${this.jobDetails['Job_Time'].substring(0, 2)}:${this.jobDetails['Job_Time'].substring(2)}` : ''}`;
      this.customer = this.jobDetails['ShprCsgn'];
      this.voyno = this.jobDetails['VoyNo'] ? this.jobDetails['VoyNo'].trim() : '';
      this.vesselETA = `${this.jobDetails['Date_ETA'] || ''} ${this.jobDetails['Time_ETA'] ? `${this.jobDetails['Time_ETA'].substring(0, 2)}:${this.jobDetails['Time_ETA'].substring(2)}` : ''}`;

      // this.remarks = '';

      // this.fromList = [];
      // this.selectedFrom = null;
      // this.toList = [];
      // this.selectedTo = null;

      this.qty = this.jobDetails['No_Package'] ? this.jobDetails['No_Package'].toString() : '';
      // this.packageList = [];
      this.selectedPackage = this.packageList.getSelected(this.jobDetails['Package_Code'], 'Package Code');
      this.kg = this.jobDetails['KG'] ? this.jobDetails['KG'].toString() : '';
      this.m3 = this.jobDetails['M3'] ? this.jobDetails['M3'].toString() : '';

      this.goodsDesc = this.jobDetails['GoodsDesc'] ? this.jobDetails['GoodsDesc'].trim() : '';
      this.shipMarks = this.jobDetails['ShipMark'] ? this.jobDetails['ShipMark'].trim() : '';
    },
    populateEditDetails: async function (dnNo) {
      const resolvedDnNo = this.selectedDN?.[0]?.['Delivery Note #']?.trim() || dnNo;

      this.$fullscreenLoading('Populating Details');
      const details = (await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteDetails?dnno=${resolvedDnNo}`))[0];

      this.dnno = resolvedDnNo;
      this.refno = details['RefNo'];

      const date = details['ROTDate'] ? new Date(details['ROTDate']).formatString('yyyy-MM-dd') : '';
      const time = details['ROTTime'] ? details['ROTTime'].split('') : [];
      if (time.length == 4) {
        time.splice(2, 0, ':');
      }
      const dateTimeStr = `${date} ${time.join('')}`;
      if (!dateTimeStr.trim()) {
        this.dnDateTime = null;
      } else {
        this.dnDateTime = new Date(dateTimeStr);
      }

      if (details['VehicleNo']) {
        const hasSelectedLorry = this.lorryNoList.find((l) => l['Lorry No'].trim() == details['VehicleNo'].trim());
        if (hasSelectedLorry) {
          this.selectedLorry = hasSelectedLorry;
        } else {
          this.selectedLorry = null;
          this.otherLorryNoChecked = true;
          await this.$nextTick();
          this.otherLorryNo = details['VehicleNo'];
        }
      } else {
        this.selectedLorry = null;
        this.otherLorryNo = '';
        this.otherLorryNoChecked = false;
      }
      if (details['DriverName']) {
        const hasSelectedDriver = this.driverCodeList.find(
          (d) => d['Driver Name'].trim() == details['DriverName'].trim(),
        );
        if (hasSelectedDriver) {
          this.selectedDriver = hasSelectedDriver;
          this.driverCodeChanged(this.selectedDriver);
        } else {
          this.selectedDriver = null;
          this.driverName = details['DriverName'];
        }
      } else {
        this.selectedDriver = null;
        this.driverName = '';
      }
      this.selectedTransporter =
        details['Ctr_Creditor'] ?
          this.transporterList.find((t) => t['Creditor Code'].trim() == details['Ctr_Creditor'].trim())
        : null;

      this.selectedJobNo = details['Job_No'] ? details['Job_No'].trim() : '';
      // this.jobDateTime = `${details['ROTDate'] ? new Date(details['ROTDate']).formatString('yyyy-MM-dd') : ''} ${details['ROTTime'] ? `${details['ROTTime'].substring(0,2)}:${details['ROTTime'].substring(2)}` : ''}`;
      this.jobDateTime = `${details['JobDate'] ? new Date(details['JobDate']).formatString('yyyy-MM-dd') : ''} ${details['JobTime'] ? `${details['JobTime'].substring(0, 2)}:${details['JobTime'].substring(2)}` : ''}`;
      this.customer = details['Cu_Number'] ? details['Cu_Number'].trim() : '';
      this.voyno = details['VoyNo'] ? details['VoyNo'].trim() : '';
      this.vesselETA = details['Date_ETA'] ? details['Date_ETA'].trim() : '';

      this.remarks = details['Remarks'] ? details['Remarks'].trim() : '';

      this.selectedFrom =
        details['DepartureCode'] ?
          this.fromList.find((f) => f['Destination Code'].trim() == details['DepartureCode'].trim())
        : null;
      this.fromChanged(this.selectedFrom);
      this.selectedTo =
        details['DestinationCode'] ?
          this.toList.find((f) => f['Destination Code'].trim() == details['DestinationCode'].trim())
        : null;
      this.toChanged(this.selectedTo);

      this.qty = details['Quantity'] ? details['Quantity'].toString() : '';
      this.selectedPackage =
        details['Package_Code'] ?
          this.packageList.find((f) => f['Package Code'].trim() == details['Package_Code'].trim())
        : null;
      this.kg = details['GWeight'] ? details['GWeight'].toString() : '';
      this.m3 = details['Measurement'] ? details['Measurement'].toString() : '';

      this.goodsDesc = details['GoodsDescription'] ? details['GoodsDescription'].trim() : '';
      this.shipMarks = details['ShipMarks'] ? details['ShipMarks'].trim() : '';

      //populate packing list
      if (details['PackingList']) {
        let packages = [];
        if (Array.isArray(details['PackingList'])) {
          // Has multiple sub package
          packages = details['PackingList'];
        } else {
          // Has one sub package
          packages = [details['PackingList']];
        }

        packages.forEach((p) => {
          const TotalGrossKG = p['Total Gross KG'] ? this.$weightFormat(p['Total Gross KG']) : this.$weightFormat('0');
          const PerPkgKG = p['Per Pkg KG'] ? this.$weightFormat(p['Per Pkg KG']) : this.$weightFormat('0');
          const TotalNettKG = p['Total Nett KG'] ? this.$weightFormat(p['Total Nett KG']) : this.$weightFormat('0');
          const PerPkgNettKG =
            p['Per Pkg Nett KG'] ? this.$weightFormat(p['Per Pkg Nett KG']) : this.$weightFormat('0');
          const TotalVolM3 = p['Total Vol M3'] ? this.$weightFormat(p['Total Vol M3']) : this.$weightFormat('0');
          const PerPkgM3 = p['Per Pkg M3'] ? this.$weightFormat(p['Per Pkg M3']) : this.$weightFormat('0');

          const Length = p['Length'] ? this.$weightFormat(p['Length']) : this.$weightFormat('0');
          const Width = p['Width'] ? this.$weightFormat(p['Width']) : this.$weightFormat('0');
          const Height = p['Height'] ? this.$weightFormat(p['Height']) : this.$weightFormat('0');

          this.dnSubPkgList.push({
            'Package Quantity': p['SubPackages Qty'],
            'Package Type': p['SubPackage Code'] ? p['SubPackage Code'] : '',
            Dimensions: `${Length}m X ${Width}m X ${Height}m`,
            'Gross Weight': `${TotalGrossKG}KG (${PerPkgKG}KG)`,
            'Net Weight': `${TotalNettKG}KG (${PerPkgNettKG}KG)`,
            Volume: `${TotalVolM3}M³ (${PerPkgM3}M³)`,
            'Item Code': p['Item Code'] ? p['Item Code'] : '',
            'Packing List #': p['Packing List No'] || '',
            'Invoice #': p['Invoice No'] || '',
            'Container #': p['Container No'] || '',
            Remarks: p['Remarks'] || '',
            // item_action: '',
            seq_no: p['SeqNo'] || '',
          });
        });
      }
      this.$fullscreenLoading();
    },
    populateSubPackagesDetails: async function () {
      this.subPkgList = []; // reset list
      // weishen 20260114 - Get Sub packages details from Job
      const getJobDetails = await this.$apiCallV2(`/FreightForwarding/JobDetails?jobno=${this.selectedJobNo.trim()}`);
      const jobDetails = getJobDetails['JobDetails']['Job'];

      if (jobDetails['PackingList']) {
        let packages = [];
        if (Array.isArray(jobDetails['PackingList'])) {
          // Has multiple sub package
          packages = jobDetails['PackingList'];
        } else {
          // Has one sub package
          packages = [jobDetails['PackingList']];
        }

        const consumedMap = await this.getConsumedQtyMap();

        packages.forEach((p) => {
          const originalQty = Number(p['SubPackages Qty']) || 0;
          const consumedQty = consumedMap[p['SeqNo']] || 0;

          const remainingQty = originalQty - consumedQty;
          // skip if fully consumed
          if (remainingQty <= 0) return;

          const TotalGrossKG = p['Total Gross KG'] ? this.$weightFormat(p['Total Gross KG']) : this.$weightFormat('0');
          const PerPkgKG = p['Per Pkg KG'] ? this.$weightFormat(p['Per Pkg KG']) : this.$weightFormat('0');
          const TotalNettKG = p['Total Nett KG'] ? this.$weightFormat(p['Total Nett KG']) : this.$weightFormat('0');
          const PerPkgNettKG =
            p['Per Pkg Nett KG'] ? this.$weightFormat(p['Per Pkg Nett KG']) : this.$weightFormat('0');
          const TotalVolM3 = p['Total Vol M3'] ? this.$weightFormat(p['Total Vol M3']) : this.$weightFormat('0');
          const PerPkgM3 = p['Per Pkg M3'] ? this.$weightFormat(p['Per Pkg M3']) : this.$weightFormat('0');

          const Length = p['Length'] ? this.$weightFormat(p['Length']) : this.$weightFormat('0');
          const Width = p['Width'] ? this.$weightFormat(p['Width']) : this.$weightFormat('0');
          const Height = p['Height'] ? this.$weightFormat(p['Height']) : this.$weightFormat('0');

          this.subPkgList.push({
            'Package Quantity': remainingQty, // use remaining qty
            'Package Type': p['SubPackage Code'] ? p['SubPackage Code'] : '',
            Dimensions: `${Length}m X ${Width}m X ${Height}m`,
            'Gross Weight': `${TotalGrossKG}KG (${PerPkgKG}KG)`,
            'Net Weight': `${TotalNettKG}KG (${PerPkgNettKG}KG)`,
            Volume: `${TotalVolM3}M³ (${PerPkgM3}M³)`,
            'Item Code': p['Item Code'] ? p['Item Code'] : '',
            'Packing List #': p['Packing List No'] || '',
            'Invoice #': p['Invoice No'] || '',
            'Container #': p['Container No'] || '',
            Remarks: p['Remarks'] || '',
            // item_action: '',
            seq_no: p['SeqNo'] || '',
          });
        });
      }
    },

    // Page 1 methods
    page1Refresh: async function () {
      this.selectedJob = null;
      this.jobsList = [];

      this.$fullscreenLoading('Getting Job List');
      await this.$nextTick();
      this.jobsList = await this.$apiCallV2(
        `/DeliveryNotes/GetJobDetails?startdate=${new Date(this.startDate).formatString('yyyy-MM-dd')}&enddate=${new Date(this.endDate).formatString('yyyy-MM-dd')}`,
      );
      // this.jobsList = await this.$apiCallV2(`/DeliveryNotes/GetJobDetails`);
      this.$fullscreenLoading();
    },
    // Page 1 methods

    // Page 2 methods
    driverCodeChanged: function (e) {
      if (!e) {
        return;
      }
      this.driverName = e['Driver Name'] ? e['Driver Name'].trim() : '';
      this.driverIC = e['Driver IC'] ? e['Driver IC'].trim() : '';
    },
    fromChanged: function (e) {
      if (!e) {
        return;
      }
      this.fromAddress = `${e['Address']}\r${e['PostCode']}, ${e['City']},\r${e['State']}, ${e['Country']}`;
    },
    toChanged: function (e) {
      if (!e) {
        return;
      }
      this.toAddress = `${e['Address']}\r${e['PostCode']}, ${e['City']},\r${e['State']}, ${e['Country']}`;
    },
    // Page 2 methods

    clearData: function () {
      // Clear page 1 data
      this.selectedJobNo = '';
      this.jobsList = [];
      this.selectedJob = null;
      this.subPkgList = [];
      this.dnSubPkgList = [];
      this.selectedCargoInfoData = {
        selectedSubPkgs: [],
      };
      // Clear page 1 data

      // Clear page 2 data
      this.jobDetails = null;

      this.jobDetails = null;
      this.dnno = '';
      this.refno = '';
      this.dnDateTime = null;

      this.otherLorryNoChecked = false;
      this.otherLorryNo = '';
      this.selectedLorry = null;
      this.selectedDriver = null;
      this.driverName = '';
      this.driverIC = '';
      this.selectedTransporter = null;

      this.jobno = '';
      this.jobDateTime = '';
      this.customer = '';
      this.voyno = '';
      this.vesselETA = '';

      this.remarks = '';

      this.selectedFrom = null;
      this.fromAddress = '';
      this.selectedTo = null;
      this.toAddress = '';

      this.qty = '';
      this.selectedPackage = null;
      this.kg = '';
      this.m3 = '';

      this.goodsDesc = '';
      this.shipMarks = '';
      // Clear page 2 data

      this.popupEntryTitle = '';

      this.clearAllPopupEntryMessages();

      this.VehicleNoError = '';
      this.DriverNameError = '';
      this.Ctr_CreditorError = '';
      this.DepartureCodeError = '';
      this.DestinationCodeError = '';
      this.QuantityError = '';
      this.Package_CodeError = '';
      this.GWeightError = '';
      this.MeasurementError = '';
      this.goodsDescError = '';
      this.shipMarksError = '';
    },
    clearAllPopupEntryMessages: function () {
      this.popupEntryRequired = [];
      this.popupEntrySuccess = [];
      this.popupEntryMessages = [];
      this.popupEntryError = [];
    },
    requiredClicked: function (e) {
      this.$refs[e].setFocus();
    },
    searchBySelected: function (e) {
      if (e) {
        if (e['Search Criteria'] == 'Required Date') {
          this.selectedCriteria = this.searchCriteriaItems[0];
          this.criteriaDisabled = true;
        } else {
          this.criteriaDisabled = false;
        }
      }
    },

    popupButtonClicked: async function (e) {
      this.popupShow = false;
      this.popupButtons = [];

      if (e == 'Delete') {
        const dataToPost = {
          lastupdate: new Date().formatString('yyyy-MM-dd HH:mm:ss'),
          action: 'D',
          ROTNo: this.selectedDN[0]['Delivery Note #'].trim(),
          Job_No: this.selectedDN[0]['Job #'].trim(),
        };

        this.$fullscreenLoading('Deleting Delivery Note');
        const deleteResults = await this.$apiCallV2('/DeliveryNotes/SaveDeliveryNote', dataToPost);
        this.$fullscreenLoading();

        this.popupShow = true;
        this.popupType = deleteResults[0]['Results'] == 0 ? 'success' : 'error';
        this.popupTitle = deleteResults[0]['Results'] == 0 ? 'Delivery Note Deleted' : 'Delivery Note Not Deleted';
        this.popupContent =
          deleteResults[0]['Results'] == 0 ?
            `Successfully deleted delivery note ${this.selectedDN[0]['Delivery Note #']}`
          : `An error occurred while deleting delivery note ${this.selectedDN[0]['Delivery Note #']}. Please try again.`;

        if (deleteResults[0]['Results'] == 0) {
          this.refreshClicked();
        }
      }
    },
    getConsumedQtyMap: async function () {
      const map = {};

      // 1) consumed by current DN (already in UI)
      this.dnSubPkgList.forEach((p) => {
        const key = p.seq_no;
        if (!key) return;

        map[key] = (map[key] || 0) + Number(p['Package Quantity'] || 0);
      });

      // 2) consumed by OTHER DNs (from backend)
      const resp = await this.$apiCallV2(`/DeliveryNotes/GetTransportRequestDetailsByJob?jobno=${this.selectedJobNo}`);
      // current DN number
      const currentDnNo = this.selectedDN?.[0]?.['Delivery Note #'];

      resp.forEach((r) => {
        // exclude current DN
        if (currentDnNo && r['ROT No'] === currentDnNo) return;

        const key = r.SeqNo;
        if (!key) return;
        map[key] = (map[key] || 0) + Number(r['SubPackages Qty'] || 0);
      });

      return map;
    },
    qtyPopupButtonClicked: function (btn) {
      if (btn === 'Confirm') {
        this.confirmQty();
      } else {
        this.closeQtyPopup();
      }
    },
    confirmQty: async function () {
      const selected = this.selectedCargoInfoData['selectedSubPkgs'];
      if (!selected || selected.length !== 1) return;
      const selectedRow = selected[0];
      const qty = Number(this.inputQty); // number of items
      if (!qty || qty <= 0) return;

      // find source index
      const idx = this.subPkgList.findIndex((r) => r.seq_no === selectedRow.seq_no);

      const sourceRow = this.subPkgList[idx];
      const available = Number(sourceRow['Package Quantity']) || 0;
      if (qty > available) {
        //check qty not exceed total
        this.$showAlert('error', `Quantity cannot exceed ${available}`, 'Please retype the quantity');
        return;
      }

      // push to DN list start
      const dnIdx = this.dnSubPkgList.findIndex((r) => r.seq_no === selectedRow.seq_no);

      if (dnIdx !== -1) {
        // amend existing DN record
        const existingQty = Number(this.dnSubPkgList[dnIdx]['Package Quantity']) || 0;
        this.dnSubPkgList.splice(dnIdx, 1, {
          ...this.dnSubPkgList[dnIdx],
          'Package Quantity': existingQty + qty,
        });
      } else {
        // first time add
        this.dnSubPkgList.push({
          ...sourceRow,
          'Package Quantity': qty,
        });
      }
      // push to DN list end

      const remaining = available - qty;
      // replace subPkgList array item to set the remaining qty
      if (remaining > 0) {
        this.subPkgList.splice(idx, 1, {
          ...sourceRow,
          'Package Quantity': remaining,
        });
      } else {
        // remove row if zero
        this.subPkgList.splice(idx, 1);
      }

      // FORCE all TableBox to refresh
      const tempsubPkgList = [...this.subPkgList];
      const tempdnSubPkgList = [...this.dnSubPkgList];
      this.subPkgList = [];
      this.dnSubPkgList = [];
      this.showSelectPackagePopup = false;
      this.showSelectPackagePopup = true;

      await this.$sleep(500);
      this.subPkgList = tempsubPkgList;
      this.dnSubPkgList = tempdnSubPkgList;

      this.closeQtyPopup();
      if (this.subPkgList.length === 0) {
        // if no more sub package, close select package popup
        this.showSelectPackagePopup = false;
      }
    },

    closeQtyPopup: function () {
      this.showQtyPopup = false;
      this.inputQty = 0;
      this.selectedCargoInfoData['selectedSubPkgs'] = [];
    },
    openQtyPopup: async function (_row) {
      this.inputQty = String(this.selectedCargoInfoData['selectedSubPkgs'][0]['Package Quantity']);
      this.showQtyPopup = true;
      await this.$sleep(500);
      this.$nextTick(() => {
        this.$refs.qtyInput?.selectText();
      });
    },
    confirmEditQty: async function () {
      const selected = this.selectedCargoInfoData['selectedSubPkgs'];
      if (!selected || selected.length !== 1) return;

      const selectedRow = selected[0];
      const newQty = Number(this.inputQty);

      if (!newQty || newQty <= 0) return;

      // find DN row
      const dnIdx = this.dnSubPkgList.findIndex((r) => r.seq_no === selectedRow.seq_no);
      if (dnIdx === -1) return;

      const dnRow = this.dnSubPkgList[dnIdx];
      const oldQty = Number(dnRow['Package Quantity']) || 0;
      const diff = newQty - oldQty;

      // find source row
      const srcIdx = this.subPkgList.findIndex((r) => r.seq_no === selectedRow.seq_no);
      const srcRow = this.subPkgList[srcIdx];
      const available = Number(srcRow?.['Package Quantity']) || 0;

      // 🔴 validation when increasing
      if (diff > 0 && diff > available) {
        this.$showAlert('error', `Quantity cannot exceed ${oldQty + available}`, 'Please retype the quantity');
        return;
      }

      // ✅ update DN qty
      this.dnSubPkgList.splice(dnIdx, 1, {
        ...dnRow,
        'Package Quantity': newQty,
      });

      // ✅ adjust source qty
      if (diff > 0) {
        // take more from source
        const remaining = available - diff;
        if (remaining > 0) {
          this.subPkgList.splice(srcIdx, 1, {
            ...srcRow,
            'Package Quantity': remaining,
          });
        } else {
          this.subPkgList.splice(srcIdx, 1);
        }
      } else if (diff < 0) {
        // return qty back to source
        const returnQty = Math.abs(diff);

        if (srcIdx !== -1) {
          this.subPkgList.splice(srcIdx, 1, {
            ...srcRow,
            'Package Quantity': available + returnQty,
          });
        } else {
          // source row was removed earlier, reinsert it
          this.subPkgList.push({
            ...dnRow,
            'Package Quantity': returnQty,
          });
        }
      }

      // 🔄 force refresh tables
      const tempSub = [...this.subPkgList];
      const tempDn = [...this.dnSubPkgList];
      this.subPkgList = [];
      this.dnSubPkgList = [];

      await this.$sleep(200);

      this.subPkgList = tempSub;
      this.dnSubPkgList = tempDn;

      this.closeQtyPopup();
    },

    selectPackageClicked: async function () {
      this.showSelectPackagePopup = true;
      this.selectedDnSubPkgList = [];

      await this.$sleep(500);
      await this.populateSubPackagesDetails();

    },
    deletePackageClicked: async function () {
      const selected = this.selectedDnSubPkgList;
      if (!selected || selected.length !== 1) {
        this.$showAlert('error', 'No Sub Package selected', 'Please select a record to delete');
        return;
      }
      const confirmDelete = await this.$showAlert(
        'warning',
        'Delete Package',
        'Are you sure you want to delete the selected package?',
        [
          { text: 'Delete', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'gray', textColor: 'white' },
        ],
      );
      if (confirmDelete == 'Delete') {
        this.deleteDnPackage(selected[0]);
      }
    },
    deleteDnPackage: async function (dnRow) {
      const qtyToRestore = Number(dnRow['Package Quantity']) || 0;
      if (qtyToRestore <= 0) return;

      // remove from DN list
      const dnIdx = this.dnSubPkgList.findIndex((r) => r.seq_no === dnRow.seq_no);
      if (dnIdx === -1) return;
      this.dnSubPkgList.splice(dnIdx, 1);

      // restore qty to subPkgList
      const subIdx = this.subPkgList.findIndex((r) => r.seq_no === dnRow.seq_no);
      if (subIdx !== -1) {
        // add back quantity
        const currentQty = Number(this.subPkgList[subIdx]['Package Quantity']) || 0;
        this.subPkgList.splice(subIdx, 1, {
          ...this.subPkgList[subIdx],
          'Package Quantity': currentQty + qtyToRestore,
        });
      } else {
        // recreate row (use DN row as base)
        this.subPkgList.push({
          ...dnRow,
          'Package Quantity': qtyToRestore,
        });
      }

      // FORCE all TableBox to refresh
      const tempsubPkgList = [...this.subPkgList];
      const tempdnSubPkgList = [...this.dnSubPkgList];
      this.subPkgList = [];
      this.dnSubPkgList = [];

      await this.$sleep(500);
      this.subPkgList = tempsubPkgList;
      this.dnSubPkgList = tempdnSubPkgList;
    },
    selectPackageButtonClicked: function (button) {
      if (button === 'Select All') {
        this.selectAllPackages();
      } else if (button == 'Close') {
        this.showSelectPackagePopup = false;
      }
    },
    selectAllPackages: async function () {
      if (!this.subPkgList.length) return;
      this.subPkgList.forEach((pkg) => {
        const qty = Number(pkg['Package Quantity']) || 0;
        if (qty <= 0) return;

        const dnIdx = this.dnSubPkgList.findIndex((r) => r.seq_no === pkg.seq_no);
        if (dnIdx !== -1) {
          // merge qty
          const existingQty = Number(this.dnSubPkgList[dnIdx]['Package Quantity']) || 0;
          this.dnSubPkgList.splice(dnIdx, 1, {
            ...this.dnSubPkgList[dnIdx],
            'Package Quantity': existingQty + qty,
          });
        } else {
          // add new DN row
          this.dnSubPkgList.push({
            ...pkg,
            'Package Quantity': qty,
          });
        }
      });

      // clear all remaining sub packages
      this.subPkgList = [];

      // FORCE all DN table to refresh
      const tempdnSubPkgList = [...this.dnSubPkgList];
      this.dnSubPkgList = [];
      await this.$sleep(500);
      this.dnSubPkgList = tempdnSubPkgList;

      // close popup
      this.showSelectPackagePopup = false;
    },
    confirmSelectPackage: function () {
      const selected = this.selectedCargoInfoData['selectedSubPkgs']
        .filter((p) => p.selectQty && p.selectQty > 0)
        .map((p) => ({
          ...p,
          qty: p.selectQty,
        }));

      this.dnSubPkgList.push(...selected);

      // cleanup
      this.selectedCargoInfoData['selectedSubPkgs'].forEach((p) => (p.selectQty = 0));
      this.showSelectPackagePopup = false;
    },
    formatPkgList: function () {
      if (this.dnSubPkgList?.length < 1) {
        return [];
      }

      const formatted = this.dnSubPkgList.map((p) => {
        const dim = p['Dimensions'].split('X');
        const gWeight = p['Gross Weight'].replaceAll(',', '').split('KG');
        const nWeight = p['Net Weight'].replaceAll(',', '').split('KG');
        const uom = p['Volume'].replaceAll(',', '').split('M³');
        return {
          seq_no: p['seq_no'],
          packageqty: p['Package Quantity'],
          packageheight: dim[2].replaceAll('m', '').replaceAll(',', '').trim(),
          packagewidth: dim[1].replaceAll('m', '').replaceAll(',', '').trim(),
          packagelength: dim[0].replaceAll('m', '').replaceAll(',', '').trim(),
          packageweight: gWeight[1].replace('(', '').trim(),
          packageuom: uom[1].replace('(', '').trim(),
          remarks: p['Remarks'],
          actionflag: p['item_action'] || 'D',
          prod_code: p['Item Code'],
          balquantity: '',
          balweight: '',
          baluom: '',
          packagenweight: nWeight[1].replace('(', '').trim(),
          totalweight: gWeight[0].trim(),
          totaluom: uom[0].trim(),

          totalnweight: nWeight[0].trim(),
          itemvalue: '',
          packinglistno: p['Packing List #'],
          invoiceno: p['Invoice #'],
          cont_no: p['Container #'],
          package_code: p['Package Type'],
        };
      });

      return formatted;
    },

    openFromParams() {
      const params = new URLSearchParams(window.location.search);

      const newValue = params.get('New');
      if (newValue != null) this.menuClicked({ title: 'New Delivery Note' });
    },

    onLorryChanged() {
      if(!this.selectedTransporter && this.selectedLorry){
        this.selectedTransporter = this.transporterList.getSelected(
          this.defaultValueToPopulate[0]['DefaultTransporter'] || '',
          'Creditor Code'
        );
      }


    } 
  },
  async mounted() {
    this.fromDatePicker = new Date();
    this.toDatePicker = new Date();

    this.$fullscreenLoading('Getting Job Query');
    this.searchFilterItems = await this.$apiCallV2('/Master/GetListMaster', {
      masterfile: 'JOBQUERY',
      module: 'CONTLESS',
    });

    this.$fullscreenLoading('Getting Lorry No');
    this.lorryNoList = await this.$apiCallV2('/DeliveryNotes/GetListMaster?masterFile=lorryno');

    this.$fullscreenLoading('Getting Default Transporter');
    this.defaultValueToPopulate = await this.$apiCallV2(
        '/DeliveryNotes/GetSettingsSystem?system=CONTLESS'
    );

    this.$fullscreenLoading('Getting Drivers');
    this.driverCodeList = await this.$apiCallV2('/DeliveryNotes/GetListMaster?masterFile=driverno');

    this.$fullscreenLoading('Getting Transporters');
    this.transporterList = await this.$apiCallV2('/DeliveryNotes/GetListMaster?masterFile=creditor');

    this.$fullscreenLoading('Getting Destinations');
    const destination = await this.$apiCallV2('/DeliveryNotes/GetListMaster?masterFile=destination');
    const mappedDestination = destination.map((d) => ({
      ...d,
      'Code - Name': `${d['Destination Code']} - ${d['Company']}`,
    }));
    this.fromList = mappedDestination;
    this.toList = mappedDestination;

    this.$fullscreenLoading('Getting Packages');
    this.packageList = await this.$apiCallV2('/DeliveryNotes/GetListMaster?masterFile=packagecode');

    if (this.$route.query['jobNo']) {
      //to filter all Delivery Note related to the jobno
      this.jobno = this.$route.query['jobNo'];
      this.selectedJobNo = this.$route.query['jobNo'];
      this.dateFilterChecked = false;
      this.searchFilterChecked = true;
      this.selectedSearchBy = this.searchFilterItems.find((obj) => obj['Search Criteria'] == 'Job #');
      this.selectedCriteria = this.searchCriteriaItems.find((obj) => obj['name'] == 'CONTAINS');
      this.searchByValue = this.$route.query['jobNo'];
      this.refreshClicked();

      if (this.$route.query['action'] == 'N') {
        //create new Delivery Note for the jobno
        const dateOnly = this.$route.query['jobDate']?.split(' ')[0];
        this.startDate = new Date(dateOnly);
        this.endDate = new Date(dateOnly);

        await this.page1Refresh();
        this.viewMode = true;
        this.popupEntryShow = true;
        this.popupEntryTitle = 'New Delivery Note';
        this.dnno = '**************';
        this.selectedJobNo = this.$route.query['jobNo'];
        this.$nextTick(() => {
          this.$refs['jobNo'].setFocus();
        });
      }
    }

    if (!this.selectedSearchBy) {
      this.selectedSearchBy = this.searchFilterItems[0];
    }

    if (!this.selectedCriteria) {
      this.selectedCriteria = this.searchCriteriaItems[2];
    }

    this.$fullscreenLoading();
    await this.refreshClicked();

    this.openFromParams();
  },
  watch: {
    'selectedCargoInfoData.selectedSubPkgs'(val) {
      if (val && val.length === 1) {
        this.openQtyPopup(val[0]);
      }
    },
    popupEntryShow: function (val) {
      if (!val) {
        this.clearData();
      }
    },
    otherLorryNoChecked: function (_val) {
      this.otherLorryNo = '';
      this.selectedLorry = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.delivery-note-main {
  display: flex;
  width: 100%;
  padding: 10px 45px;
  font-size: 12px;

  > .right-container {
    width: 100%;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > .filter-area {
      background-color: white;
      padding: 5px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      > * {
        margin-left: 5px;
      }

      > .filter-button {
        position: relative;

        > .filter-box {
          position: absolute;
          right: 0;
          top: 100%;
          border: 1px solid black;
          border-radius: 3px;
          padding: 5px;
          background-color: white;
          display: flex;
          flex-direction: column;
          z-index: 99;

          > .filter-item {
            border: 1px solid black;
            border-radius: 5px;
            padding: 5px;
            padding-top: 10px;
            margin: 5px;
            margin-top: 10px;
            position: relative;

            > .filter-check {
              position: absolute;
              top: -10px;
              background-color: white;
              padding: 0 10px;
              left: 10px;
            }

            > .dates {
              display: flex;

              > * {
                margin: 0 3px;
              }
            }
          }

          > button {
            position: relative;
            right: 5px;
            align-self: flex-end;
          }
        }
      }
    }

    > .tabulator-area {
      background-color: white;
      margin-top: 5px;
      border-radius: 5px;
      height: calc(100% - 43px);
      padding: 5px;
    }
  }
}

.tabtab {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 38px;
}

.destTable {
  padding-bottom: 2.5%;
  padding: 5px;
  border-radius: 5px;
  background-color: white;
  height: calc(100% - 44px);
}

.dateTimePickerDiv {
  width: 100%;
  // margin-left: 5px;
}

.sideByDiv {
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  // > * {
  // 	margin-left: 10px;
  // }
}

.page1-popup {
  height: calc(100% - 58px);

  > .page1-date-filter {
    display: flex;
    align-items: center;

    > * {
      margin-right: 15px !important;
    }
  }
}

.page2-popup {
  // display: flex;
  // flex-direction: column;
  width: 100%;
  overflow: auto;
}

.popup-row {
  display: flex;

  > :first-child {
    margin-right: 5px;
  }

  > * {
    width: 50%;
  }

  > .block-with-title {
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    position: relative;
    margin-top: 10px;
    padding-top: 10px;

    > .title {
      background-color: white;
      padding: 3px 10px;
      font-weight: bold;
      position: absolute;
      top: -13px;
    }
  }

  > textarea {
    resize: none;
    height: 100px;
  }
}
.table-container {
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 5px;
  margin-top: 3px;

  > .tabulator-title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    > button {
      margin-left: 3px;
    }
  }
}
.generateList-table {
  margin: 5px;
  height: 80%;
}
</style>
